export default (entityPropsName = 'entityName') => {
  return {
    props: {
      isSearchApi: Boolean
    },
    inject: {
      ApiFactory: {
        default: () => ({})
      },
      searchApiMethod: {
        default: () => ({})
      }
    },
    computed: {
      api () {
        return new this.ApiFactory().create(this[entityPropsName])
      },
      searchItems () {
        return async (query, searchParams = {}, params) => {
          const { data } = await this.searchApiMethod(
            this[entityPropsName],
            query,
            searchParams,
            params
          )
          return data
        }
      }
    }
  }
}
